import helper from "./helper";

export default (app) => {
  app.use(helper);
};
